import {
  StylesProvider,
  ThemeProvider as MuiThemeProvider,
} from "@material-ui/core/styles";
import { LocalizationProvider } from "@mui/lab";
import AdapterLuxon from "@mui/lab/AdapterLuxon";
import {
  StyledEngineProvider,
  ThemeProvider as ThemeProviderV5,
} from "@mui/material/styles";
import { theme as voltThemeV5, Utility } from "@volt_developers/components";
import {
  SidebarProvider,
  theme as voltTheme,
} from "@volt_developers/react-ui-components";
import React, { useLayoutEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch } from "react-redux";
import { ThemeProvider } from "styled-components";

import { AbilityContext } from "./context/Ability.context";
import { useDefineAbility } from "./hooks/useDefineAbility";
import MainSwitch from "./routes/switches/MainSwitch";
import { init } from "./store/appSlice";
import maTheme from "./theme";

export default function App() {
  const dispatch = useDispatch();

  //We want this to run before children useEffects
  //that are not delayed using lazy loading
  useLayoutEffect(() => {
    dispatch(init());
  }, [dispatch]);

  const ability = useDefineAbility();

  return (
    <React.Fragment>
      <Utility.Normalize />
      <Helmet titleTemplate="%s - Volt Fuzebox" defaultTitle="Volt Fuzebox" />
      <AbilityContext.Provider value={ability}>
        <StyledEngineProvider injectFirst>
          <StylesProvider injectFirst>
            <ThemeProvider theme={maTheme}>
              <MuiThemeProvider theme={voltTheme}>
                <ThemeProviderV5 theme={voltThemeV5}>
                  <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <SidebarProvider>
                      <MainSwitch />
                    </SidebarProvider>
                  </LocalizationProvider>
                </ThemeProviderV5>
              </MuiThemeProvider>
            </ThemeProvider>
          </StylesProvider>
        </StyledEngineProvider>
      </AbilityContext.Provider>
    </React.Fragment>
  );
}
